<template>
  <div class="bar-select">
    <header class="header">
      <div class="contact">
        <div class="contact-label">Служба поддержки</div>
        <div class="contact-number">+7 (343) 3-726-726</div>
      </div>
    </header>

    <div class="form">
      <h1>Укажите, где вам будет удобно забрать заказ</h1>

      <div class="form-inputs">
        <div class="line">
          <div class="form-group">
            <label for="cities">Город</label>
            <select
              name="selectCity"
              id="cities"
              @change="selectChange"
              v-model="data.barForm.selectCity"
              :disabled="cityIsDisabled"
            >
              <option value="" disabled selected hidden>Город</option>
              <option
                v-if="data.cities"
                v-for="city in data.cities"
                :value="city.id"
                :key="city.id"
              >
                {{ city.name }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Дата</label>
            <DatePicker
              name="selectDate"
              v-model="data.barForm.selectDate"
              format="YYYY-MM-DD"
              type="date"
              placeholder="Дата"
              @change="changeDate"
              :disabled-date="disabledBeforeTodayAndAfterAWeek"
              lang="ru"
            ></DatePicker>
          </div>
        </div>

        <div class="line">
          <div class="form-group">
            <label for="cinema">Площадка</label>
            <select
              name="selectTheatre"
              class="cinema"
              :disabled="!data.barForm.selectCity || theatreIsDisabled"
              id="cinema"
              type="text"
              @change="selectChange"
              v-model="data.barForm.selectTheatre"
            >
              <option value="" disabled selected hidden>Площадка</option>
              <option
                v-for="theatre in data.cities && data.barForm.selectCity
                  ? data.cities.find(({ id }) => id === data.barForm.selectCity)
                      .Theatres
                  : []"
                :value="theatre.Id"
                :key="theatre.Id"
              >
                {{ theatre.Name }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Время</label>
            <DatePicker
              :disabled="
                !data.barForm.selectTheatre || !data.barForm.selectDate
              "
              name="selectTime"
              v-model="data.barForm.selectTime"
              :minute-step="5"
              format="HH:mm"
              value-type="format"
              type="time"
              placeholder="Время"
              @change="changeDate"
              :disabled-time="notBeforeNineOClock"
              lang="ru"
            ></DatePicker>
          </div>
        </div>
      </div>
    </div>

    <div class="button-next" @click="toNextPage">
      <div class="basket-step-forward">
        <div class="basket-btn">
          <span class="btn-label">Продолжить</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';
import { types } from '@/types';

export default {
  name: 'BarSelect',

  data() {
    return {
      selectCity: '',
      selectTheatre: '',
      selectTime: null,
      selectDate: null,
      productFolder: '',
      productId: '',
      theatreIsDisabled: false,
      cityIsDisabled: false,
    };
  },

  components: {
    DatePicker,
  },

  computed: {
    ...mapState(['data', 'theatre']),
  },

  mounted() {
    this.$store.dispatch('loadStartPageBeforeBuyBar', this.$route.query);

    this.selectCity = this.$route.query.cityId;
    this.selectTheatre = this.$route.query.theatreId;
    this.productFolder = this.$route.query.productFolder;
    this.productId = this.$route.query.productId;
    if (this.data.cities) this.cityAndTheatreIsDisabled();

    if (this.$route.query.city) {
      this.$store.dispatch('changeFormForBar', {
        name: 'selectCity',
        value: this.$route.query.city,
      });
    }
  },

  watch: {
    'data.cities': {
      handler() {
        this.cityAndTheatreIsDisabled();
      },
    },
  },

  methods: {
    cityAndTheatreIsDisabled() {
      const cityQuery = this.data.cities.find(
        ({ id }) => id === this.selectCity,
      );

      if (cityQuery) {
        this.$store.dispatch('changeFormForBar', {
          name: 'selectCity',
          value: this.selectCity,
        });
        this.cityIsDisabled = true;

        if (
          cityQuery.Theatres.find((theatre) => theatre.Id == this.selectTheatre)
        ) {
          this.$store.dispatch('getTheatreInfo', {
            theatreId: this.selectTheatre,
          });
          this.$store.dispatch('changeFormForBar', {
            name: 'selectTheatre',
            value: this.selectTheatre,
          });
          this.theatreIsDisabled = true;
        }
      }
    },
    disabledBeforeTodayAndAfterAWeek(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return (
        date < today || date > new Date(today.getTime() + 7 * 24 * 3600 * 1000)
      );
    },
    notBeforeNineOClock(date) {
      const { Closing, Opening } =
        this.theatre.WorkRangeByDaysOfWeek[
          new Date(this.data.barForm.selectDate).getDay()
        ];
      const [closingHours, closingMinutes] = Closing.split(':');
      const [openingHours, openingMinutes] = Opening.split(':');

      const closingInMinutes =
        Number(closingHours) * 60 + Number(closingMinutes);
      const openingInMinutes =
        Number(openingHours) * 60 + Number(openingMinutes);
      const currentDateInMinutes =
        new Date(date).getHours() * 60 + new Date(date).getMinutes();

      const disableInWorkRangeByDaysOfWeek =
        currentDateInMinutes < openingInMinutes ||
        currentDateInMinutes > closingInMinutes;

      if (
        new Date().getDay() ===
          new Date(this.data.barForm.selectDate).getDay() ||
        disableInWorkRangeByDaysOfWeek
      ) {
        return (
          disableInWorkRangeByDaysOfWeek ||
          date.getHours() * 60 + date.getMinutes() <=
            new Date().getHours() * 60 + date.getMinutes()
        );
      }

      return false;
    },
    selectChange(e) {
      const { name, value } = e.target;

      if (name === 'selectCity') {
        this.$store.dispatch('changeFormForBar', {
          name: 'selectCity',
          value,
        });
      }

      if (name === 'selectTheatre') {
        this.$store.commit(types.CLEAR_BAR, true);
        this.$store.dispatch('getTheatreInfo', { theatreId: value });
        this.$store.dispatch('changeFormForBar', { name, value });
      }
    },
    defaultTime() {
      const date = this.data.barForm.selectDate;
      const { Opening } =
        this.theatre.WorkRangeByDaysOfWeek[new Date(date).getDay()];
      const [openingHours] = Opening.split(':').map((time) =>
        Number(time),
      );
      const hoursNow = new Date().getHours();
      return new Date(date).getTime() <= new Date().getTime() &&
        hoursNow >= openingHours
        ? String(hoursNow + 1 + ':00')
        : Opening;
    },
    changeDate(value, type) {
      if (type === 'date') {
        this.$store.dispatch('changeFormForBar', { name: 'selectDate', value });
        this.$store.dispatch('changeFormForBar', {
          name: 'selectTime',
          value: this.defaultTime(),
        });
      } else {
        this.$store.dispatch('changeFormForBar', { name: 'selectTime', value });
      }
    },
    toNextPage() {
      const { selectCity, selectTheatre, selectTime, selectDate } =
        this.data.barForm;

      if (selectCity && selectTheatre && selectTime && selectDate) {
        this.$router.push(`/${selectTheatre}/bar`);
      }
    },
  },
  beforeDestroy() {
    this.$store.commit(types.SET_DATA_BAR, {
      selectCity: this.selectCity,
      selectTheatre: this.selectTheatre,
      productFolder: this.productFolder,
      productId: this.productId,
    });
  },
};
</script>

<styles src="./BarSelect.scss" scoped lang="scss"></styles>
